import { filter } from 'rxjs/operators';
import { find } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { OrderService } from 'src/app/services/order.service';
import { SapOrdersService } from 'src/app/services/sap_orders.service';
import { UnitTypeService } from 'src/app/services/unit-type.service';
import { DriverService } from 'src/app/services/driver.service';
import { TravelService } from 'src/app/services/travel.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-travel-create-particular',
  templateUrl: './travel-create-particular.component.html',
  styleUrls: ['./travel-create-particular.component.css']
})
export class TravelCreateParticularComponent implements OnInit {
  
//#region ----------------------------------------------------------------------------------------------------VARIABLES----------------------------------------------------------------------------------------------------
  delivery_date: string = new Date().toISOString().slice(0,16);
  prd_loading_date: string = new Date().toISOString().slice(0,16);
  loading:boolean = false;
  tipo: 'carga' | 'descarga' = 'carga';
  orden: string = '';
  list_ordenes:any = [];
  plants:any;
  selectedPlant = null;
  loadPlants = false;

  // transportista
  customerName:any = '';
  selectedCustomer:any = null;
  customers:any = [];
  customersFiltradas:any = [];
  loadCustomers = false;

  units:any;
  selectedUnit = null;
  loadUnits = false;
  
  driverCurp:any = '';
  driverName:any;
  driverLastName:any;
  driverPhone:any;
  driverAddress:any;

  drivers:any;
  particularDrivers:any;
  
  driversFiltrados:any;
  selectedDriver = null;
  loadDrivers = false;

  bdList = [
    {value: 'CELFOS_PROD', text: 'Celfos'},
    {value: 'NMH_PROD', text: 'Nutrimentos Minerales de Hidalgo'},
    {value: 'PROD_NMM', text: 'Nutrimentos Minerales de Mexico'},
    {value: 'PROECO_PROD', text: 'Proeco'}
  ];
  selectedBD: any = this.bdList[0].value;

  placas:any = '' ;
  noTracto:any = '' ;
  errorMsg:string = '';
  allDrivers:any;
  successMessage:string = '';
  dateErrorMsg = '';

//#endregion ----------------------------------------------------------------------------------------------------VARIABLES----------------------------------------------------------------------------------------------------

//#region ----------------------------------------------------------------------------------------------------INICIALIZACION----------------------------------------------------------------------------------------------------
  constructor(
    private orderServ:OrderService, private customerServ:CustomerService, private unitServ:UnitTypeService,private driverServ:DriverService,
    private saporderServ:SapOrdersService, private travelServ:TravelService,private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.getCustomers();
    this.getPlants();
    this.getUnits();
    this.getDrivers();
    this.getParticularDrivers();
  }
//#endregion ----------------------------------------------------------------------------------------------------PRECARGA DE DATOS----------------------------------------------------------------------------------------------------

//#region ----------------------------------------------------------------------------------------------------GETS DATA----------------------------------------------------------------------------------------------------
  getPlants(){
    this.plants = [];
    this.orderServ.getPlants().then(plants => {
      this.loadPlants= true;
      this.plants = plants.sort((a, b) => a.id - b.id);
    });
  }
  getCustomers(){
    this.customerServ.getCustomers().then(customers => {
      this.customers = customers.filter(c => c.active).sort((a, b) => a.id - b.id);  
      this.customers.push({id: null, name: 'Cliente General'});
      this.loadCustomers = true;   
    }); 
  }
  getUnits(){
    this.units = [];
    this.unitServ.getTypes().then(types => {
      this.loadUnits= true;
      const validIds = [1,3,4,7,8,9,10,12,15,20];
      this.units = types
        .filter(type => validIds.includes(Number(type.id)))
        .sort((a, b) => a.id - b.id);     
    });
  }
  getDrivers(){
    this.drivers = [];
    this.loadDrivers = true;
    this.driverServ.getDrivers(true).then(drivers => {
      this.drivers = drivers;
      if (this.drivers && this.particularDrivers) {
        this.allDrivers =  [...this.drivers, ...this.particularDrivers];
        this.loadDrivers = false;;
      }
    });
  }
  getParticularDrivers(){
    this.particularDrivers = [];
    this.loadDrivers = true;
    this.driverServ.getParticularDrivers().then(drivers => {
      this.particularDrivers = drivers;
      if (this.drivers && this.particularDrivers) {
        this.allDrivers =  [...this.drivers, ...this.particularDrivers];
        this.loadDrivers = false;;
      }
    });
  }
  buscarorden(){
    if (this.orden == '') {
      this.showMsg('Debes ingresar un número de orden.');
      return;
    }
    if(this.list_ordenes.find((o:any) => o.orden == this.orden)){
      this.showMsg('La orden ya fue agregada a la lista.');
      return;
    }
    this.loading = true;
    if (this.tipo === 'carga') {
      this.saporderServ.getSaleOrder(this.orden,this.selectedBD).then(res => {
        this.addOrder(res.saleOrdersWS[0]);
        console.log(res.saleOrdersWS);
      }).catch(
        err => {
          this.showMsg('La orden de carga no fue encontrada en SAP. Verifique el número de orden y la base de datos seleccionada.'); 
          console.error(err);
          this.loading = false;
        }
      );
    }else{
      this.saporderServ.getPurchaseOrder(this.orden,this.selectedBD).then(res => {
        this.addOrder(res.purchaseOrdersWS[0]);
        console.log(res.purchaseOrdersWS);
      }).catch(
        err => {
          this.showMsg('La orden de compra no fue encontrada en SAP. Verifique el número de orden y la base de datos seleccionada.'); 
          console.error(err);
          this.loading = false;
        }
      );
    }
  };
//#endregion ----------------------------------------------------------------------------------------------------GETS DATA----------------------------------------------------------------------------------------------------

//#region ----------------------------------------------------------------------------------------------------FILTROS Y SELECTS----------------------------------------------------------------------------------------------------
  // Operador
  filtrarCurps() {
    this.driverCurp = this.driverCurp.toUpperCase(); 
    this.selectedDriver = null;
    if (this.driverCurp == "") {
      this.driversFiltrados = [];
      return;
    }
    this.driversFiltrados = this.allDrivers
    .filter((c: { curp: string; }) => c.curp.toUpperCase().includes(this.driverCurp) && c.curp.length == 18)
    .slice(0, 5);
  }
  seleccionarCurp(c: any) {
    this.selectedDriver = c;
    this.driverCurp = c.curp;
    this.driverName = c.name;
    this.driverLastName = c.last_name;
    this.driverPhone = c.phone_number;
    this.driverAddress = c.address;
    this.driversFiltrados = [];
  }
  // Transportista
  filtrarCustomers() {
    const search = this.customerName.toLowerCase(); 
    if (search == "") {
      this.customersFiltradas = [];
      this.selectedCustomer = null;
      return;
    }
    this.customersFiltradas = this.customers.filter((c: { name: string; }) => c.name.toLowerCase().includes(search)).slice(0, 5); 
    if (!this.customersFiltradas.find((c: { name: string; }) => c.name.toLowerCase().includes('cliente general')) ) {
      this.customersFiltradas = [
        ...this.customersFiltradas,{ id: null, name: 'Cliente General' }
      ];
    }
    
  }
  seleccionarCustomer(c: any) {
    this.selectedCustomer = c;
    this.customerName = c.name;
    this.customersFiltradas = [];
  }
//#endregion ----------------------------------------------------------------------------------------------------FILTROS Y SELECTS----------------------------------------------------------------------------------------------------

//#region ----------------------------------------------------------------------------------------------------ORDENES----------------------------------------------------------------------------------------------------

  addOrder(order:any){
    order.lines.forEach((element:any) => {
      this.list_ordenes.push({
        orden: this.orden,
        producto: element.itemDescription,
        cantidad: element.quantity,
        peso: element.weight1 ? element.weight1/1000 : 0,
      });
    });
    this.loading = false;
  };
  eliminarOrden(orden:any){
    this.list_ordenes = this.list_ordenes.filter((o:any) => (o.orden !== orden));
  };
//#endregion ----------------------------------------------------------------------------------------------------ORDENES----------------------------------------------------------------------------------------------------


//#region ----------------------------------------------------------------------------------------------------HELPERS----------------------------------------------------------------------------------------------------

  canStore(): boolean {
    if (this.loading) return false; 
    if (!this.delivery_date) {
      // this.showMsg('Falta la fecha de entrega'); 
      return false;
    }
    if (!this.prd_loading_date) {
      // this.showMsg('Falta la fecha de carga'); 
      return false;
    }
    if (!this.selectedPlant) {
      // this.showMsg('Debe seleccionar una planta'); 
      return false;
    }

    const hasDriver =
      this.selectedDriver ||
      (
        this.driverCurp && this.driverCurp.trim() && this.isValidCURP(this.driverCurp) &&
        this.driverName && this.driverName.trim() &&
        this.driverLastName && this.driverLastName.trim() &&
        this.driverPhone && this.driverPhone.trim()
      );

    if (!hasDriver) {
      // this.showMsg('Faltan datos del operador'); 
      return false;
    }

    if (!this.selectedCustomer) {
      // this.showMsg('Debe seleccionar un cliente'); 
      return false;
    }
    if (!this.placas) {
      // this.showMsg('Debe seleccionar un cliente'); 
      return false;
    }
    if (!this.selectedUnit) {
      // this.showMsg('Debe seleccionar una unidad'); 
      return false;
    }
    if (this.list_ordenes.length <= 0) {
      // this.showMsg('Debe agregar al menos una orden'); 
      return false;
    }
    return true;
  }
  checkDates(){
    const delivery = this.delivery_date;
    const prd = this.prd_loading_date;
    this.dateErrorMsg = '';

    if (prd==null || delivery==null) {
      this.dateErrorMsg = 'Las fechas de carga y entrega son obligatorias';
    }else if (prd > delivery) this.dateErrorMsg = 'Fecha de carga de producto no debe ser después de fecha de Entrega';
  };
  showModal (modal:any) {
    this.modalService.open(modal, { size: 'lg' });
  }
  confirmSave(modal:any) {
    modal.close();
    this.crearViaje();
  }
  showMsg(msg:string){
    this.errorMsg = msg;
    setTimeout(() => {
      this.errorMsg = '';
    }, 5000);
  }
  getRowSpan(orden: number, index: number): number {
    let count = 0;

    for (let i = index; i < this.list_ordenes.length; i++) {
      if (this.list_ordenes[i].orden === orden) {
        count++;
      } else break;
    }

    return count;
  }
  isFirst(orden: number, index: number): boolean {
    return index === 0 || this.list_ordenes[index - 1].orden !== orden;
  }
  setTipo(tipo:any){
    this.tipo=tipo;
    this.list_ordenes = [];
  }
  isValidCURP(curp: string): boolean {
    if (!curp) return false;

    const curpRegex = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/;
    return curpRegex.test(curp.toUpperCase());
  }
//#endregion ----------------------------------------------------------------------------------------------------HELPERS----------------------------------------------------------------------------------------------------
  
  
  dataForApi(){

    const updateDriver = this.selectedDriver ? this.selectedDriver.name !== this.driverName || this.selectedDriver.last_name !== this.driverLastName || 
    this.selectedDriver.phone_number !== this.driverPhone || this.selectedDriver.address !== this.driverAddress : false;

    const customDriver ={
      curp : this.driverCurp, 
      nombre : this.driverName, 
      apellido : this.driverLastName, 
      telefono : this.driverPhone, 
      direccion : this.driverAddress,
      updateDriver: updateDriver
    }
    const data = {
      fecha_entrega : this.delivery_date, 
      fecha_carga : this.prd_loading_date, 
      tipo: this.tipo,
      planta : this.selectedPlant, 
      operador : customDriver,
      transportista : this.selectedCustomer, 
      placas : this.placas,
      no_tracto: this.noTracto,
      unidad : this.selectedUnit, 
      ordenes : this.list_ordenes, 
    }
    return data;
  }

  handleSubmit(modal:any) {
    if(this.tipo === 'carga') this.checkDates();
    if (this.dateErrorMsg != '' && this.tipo === 'carga') {
      this.showModal(modal)
    } else {
      this.crearViaje();
    }
  }
  
 
  crearViaje(){
    this.loading = true;
    this.successMessage = '';
    this.errorMsg = '';
    const data = this.dataForApi();
    console.log(data);
    this.travelServ.postParticularTravel(data).then(response => {
      console.log(response);
      this.loading = false;
      this.successMessage = 'Viaje creado correctamente';
      setTimeout(() => {
        window.location.reload();
      }, 3000);

    }).catch(error => {
      console.error(error);
      this.loading = false;
      this.errorMsg = error && error.error && error.error.error 
        ? error.error.error : 'Ocurrió un error';
    });
  }


  // ---------------------------------MODAL-----------------------------------
  cerrarError() {
    this.errorMsg = '';
    this.successMessage = '';
  }
  // ---------------------------------MODAL-----------------------------------






//#region ----------------------------------------------------------------------------------------------------exampleregion----------------------------------------------------------------------------------------------------
//#endregion ----------------------------------------------------------------------------------------------------exampleregion----------------------------------------------------------------------------------------------------


} //END
